import React from 'react'
import {MultiSelectComponent, MultiSelectComponentProps} from 'module/CustomField/component/input/MultiSelectComponent';

const options = [
	{
		displayName: 'Ja',
		value: 'J' as 'J',
	}, {
		displayName: 'Nein',
		value: 'N' as 'N',
	},
];

export function JaNeinRadioComponent(props: Omit<MultiSelectComponentProps<'J' | 'N'>, 'options'>) {
	return <MultiSelectComponent {...props} options={options}/>;
}